export default {
  add(state, item) {
    const { id, ...data } = item;
    this._vm.$set(state.byId, id, data);
    if (state.allIds.includes(id)) return;
    state.allIds.push(id);
  },

  set(state, items) {
    state.allIds = [];
    state.byId = {};

    if (!items) return;

    for (const item of items) {
      const { id, ...data } = item;
      this._vm.$set(state.byId, id, data);
      state.allIds.push(id);
    }
  },

  update(state, item) {
    const { id, ...data } = item;
    this._vm.$set(state.byId, id, {
      ...state.byId[id],
      ...data,
    });
  },

  delete(state, id) {
    delete state.byId[id];
    state.allIds = state.allIds.filter(i => i !== id);
  },
};
